var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex ml-8",class:_vm.$style.root},[_c('div',{ref:"scrollContainer",staticClass:"d-flex",class:_vm.$style.scrollContainer},[_c('div',{staticClass:"d-flex mx-2 flex-nowrap"},[_vm._t("default")],2)]),_c('div',{class:[_vm.$style.fadeScroll, _vm.scrolling && _vm.$style.fadeScrollActive]})])
}
var staticRenderFns = []

export { render, staticRenderFns }